export enum DefaultValue {
  Dash = '–',
  NotAvailable = 'N/A',
}
